import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DispatchDatahubEvents } from '../../components/moduleCard/actions/dispatchDatahubEvents';
import { contentListQueries } from '../../queries';
import { ContentListEndpoints } from '../../services/endpoints';
import { ModuleActionsService } from '../../services/moduleActionsService';
import { queryClient } from 'src/config/request';
import { useTimeout } from 'src/core/hooks/useTimeout';
import { useWebSocket } from 'src/core/hooks/useWebSocket';
import { CONTENT_NAME_MAX_LENGTH } from 'src/modules/contentList/constants';
import { Toast } from 'src/shared/components/toast';
import { StringHelper } from 'src/shared/helpers/string';
const SUCCESS_TIMEOUT = 10000;
export function useDuplicateModule(module) {
    const { t } = useTranslation();
    const [showDuplicationModal, setShowDuplicationModal] = useState(false);
    const { connect, disconnect } = useWebSocket({
        onMessage: (message) => {
            if (message.status === 'SUCCESS') {
                Toast.show({ type: 'success', message: t('content_list.duplicate_module.success') });
                queryClient.invalidateQueries(contentListQueries.getModules({ extra: module.extra }));
                disconnect();
            }
        }
    });
    useTimeout(disconnect, SUCCESS_TIMEOUT);
    const handleDuplicateModule = useCallback(async (params) => {
        function getNewModuleName() {
            const newName = t('content_list.duplicate_page.copy_prefix', { name: module.name });
            return newName.length <= CONTENT_NAME_MAX_LENGTH ? newName : module.name;
        }
        try {
            const contextId = StringHelper.generateUUID();
            setShowDuplicationModal(false);
            Toast.show({ type: 'info', message: t('content_list.duplicate_module.pending') });
            await connect(ContentListEndpoints.waitContentDuplication(contextId));
            await ModuleActionsService.duplicateModule({
                ...params,
                contextId,
                newName: getNewModuleName()
            });
        }
        catch {
            Toast.show({ type: 'danger', message: t('content_list.duplicate_module.error') });
        }
    }, [connect, module.name, t]);
    function handleShowDuplicationModal() {
        setShowDuplicationModal(true);
        DispatchDatahubEvents.clickContentModuleDuplicateSchema(module);
    }
    function handleCloseDuplicationModal() {
        setShowDuplicationModal(false);
    }
    return {
        handleDuplicateModule,
        showDuplicationModal,
        handleShowDuplicationModal,
        handleCloseDuplicationModal
    };
}
